module.exports = __webpack_public_path__ + "img/3-4.a7af7cc9.png";